import React, { Fragment } from 'react'
import { Container, Row } from "reactstrap";
import { IconeDelete, IconeEditar, IconeGenerico } from '../../comum/components/Icones';
import BootstrapTable from "react-bootstrap-table-next";
import desovaPierService from "../../../services/DesovaPierService";
import Tooltip from '../../comum/components/Tooltip';
import lscache from 'lscache';

export default function TabelaDesova({ data, filtrar, editarSolicitacao, cancelarSolicitacao, visualizarSolicitacao, anexarDocumentos }) {
    const internoExterno = lscache.get('InternoExterno');

    const renderBotoesLinha = (_, row) => {
        const cancelMessage = row.UsuarioCancelamento === 'SISTEMA' 
        ? `Container não foi descarregado. Cancelado em ${row.DataCancelamento}`
        :`Cancelado por ${row.UsuarioCancelamento}, ${row.DataCancelamento}`;
        return (
            <div style={{display: 'flex', justifyContent: 'center'}}>
                {row.FlagStatus === 'SOLICITADO' && (row.PermiteEditar || internoExterno === 'I') && 
                    <Fragment>
                        <a onClick={() => editarSolicitacao(row.Id)}>
                            <Tooltip tooltipText='Editar'>
                                <IconeEditar tamanho="lg" className="m-2" />
                            </Tooltip>
                        </a>
                        <a onClick={() => cancelarSolicitacao(row.Id)}>
                            <Tooltip tooltipText='Cancelar'>
                                <IconeGenerico icone="ban" tamanho="lg" className="m-2" />
                            </Tooltip>
                        </a>
                    </Fragment>  
                }
                {row.FlagStatus !== 'ATENDIDO' && row.FlagStatus !== 'CANCELADO' && 
                    <a onClick={() => anexarDocumentos(row.Id)} style={row.ArqExists ? {
                        // Styles para marcar presenca de anexos
                        backgroundColor: '#BAE2E3',
                        borderRadius:  '20px',
                    }:{}}
                >
                    <Tooltip tooltipText='Anexar Documentos'>
                        <IconeGenerico icone="file-upload" tamanho="lg" className="m-2" />
                    </Tooltip>
                </a>
                }
                {row.FlagStatus === 'CANCELADO' && 
                    <Tooltip tooltipText={cancelMessage}>
                        <IconeGenerico icone="info-circle" tamanho="lg" className="m-2" naoInteragir/>
                    </Tooltip>
                }
                {(row.FlagStatus === 'ATENDIDO' || row.FlagStatus === 'CANCELADO') && 
                    <a onClick={() => visualizarSolicitacao(row.Id)}>
                        <Tooltip tooltipText='Visualizar'>
                            <IconeGenerico icone="eye" tamanho="lg" className="m-2" />
                        </Tooltip>
                    </a>
                }
            </div>

        )
    }

    const colunasPesquisa = [
        {
            dataField: 'Id',
            text: 'Id'
        }, {
            dataField: 'Documento',
            text: 'BL (Master)'
        }, {
            dataField: 'Container',
            text: 'Container'
        }, {
            dataField: 'Operacao',
            text: 'Operação'
        }, {
            dataField: 'Solicitante',
            text: 'Solicitante'
        }, {
            dataField: 'DataCriacao',
            text: 'Data da Solicitação'
        }, {
            dataField: 'FlagStatus',
            text: 'Situacao'
        }, {
            dataField: 'Acao',
            text: 'Ações',
            formatter: (col, row) => renderBotoesLinha(col, row),
            editable: false
        }
    ];

    return (
        <div className="form-wrapper">
            <Container fluid className="text-center">
                <BootstrapTable
                    keyField='Id'
                    bootstrap4
                    striped
                    bordered={false}
                    noDataIndication={"Nenhum registro encontrado."}
                    classes="tabela"
                    columns={colunasPesquisa}
                    data={data}
                />
            </Container>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/modules/desova-pier/components/TabelaDesova.js